module.exports = __webpack_public_path__ + "media/images/landing_page/kazu_budzets-01e953fcf4c1782d14996624bdf49de1.webp";